import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateBaseRoleEntity } from '../../domain/entities/UpdateBaseRoleEntity'

/**
 * A model class for updating an authorization base role.
 * It extends the `UpdateBaseRoleEntity` and transforms the `policies` property into `policyIds`.
 */
export class UpdateBaseRoleModel extends UpdateBaseRoleEntity {
  /**
   * An array of policy IDs extracted from the `policies` property of the input entity.
   */
  policyIds: number[] = []

  /**
   * Constructs a new `UpdateBaseRoleModel` instance.
   *
   * @param dataDto - The input entity to be transformed.
   * @remarks
   * The constructor uses `mapEntityProperties` to map properties from the input entity to the model instance.
   * It excludes the `policies` property and maps the `policyIds` property by extracting the IDs from the `policies` array.
   */
  constructor(dataDto: UpdateBaseRoleEntity) {
    super()
    mapEntityProperties<UpdateBaseRoleModel>(this, dataDto, {
      exclude: ['policies'],
      map: {
        policyIds: dataDto.policies?.map((policy) => policy.id)
      }
    })
  }
}
